import { gql } from '@apollo/client';
export const gtmDataQuery = gql `
  query gtmData($companyId: UUID!, $includeIndustry: Boolean!) {
    company: company2(id: $companyId) {
      id
      industry @include(if: $includeIndustry)
      industryOther @include(if: $includeIndustry)
    }
  }
`;
